import { axiosV2 } from 'interceptors/axios';
import { ApiQueryParams } from 'types';

import { decryptResponse } from 'utils/token';

type GetShareProps = {
  shareId: string;
  signal?: AbortSignal;
  params?: ApiQueryParams;
};

export const getShare = async ({ shareId, params, signal }: GetShareProps) => {
  const { data } = await axiosV2.get(`/shares/${shareId}`, {
    params,
  });

  const decodedData = await decryptResponse(data);

  return decodedData;
};
